import { useState } from 'react'
import HelpIcon from '@mui/icons-material/HelpOutlineRounded'

import { Tooltip, useTheme } from '@mui/material'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'

interface IProps {
  tooltipText: string
}

export const IconWithTooltip = ({ tooltipText }: IProps) => {
  const [open, setOpen] = useState(false)
  const theme = useTheme()

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              minWidth: '50px',
            },
          },
        }}
        title={tooltipText}
        arrow
        PopperProps={{
          disablePortal: false,
        }}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <HelpIcon
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()
            handleTooltipOpen()
          }}
          onMouseLeave={() => handleTooltipClose()}
          style={{ cursor: 'pointer' }}
          sx={{
            width: '16px',
            height: '16px',
            color: theme.palette.custom.grey3,
          }}
        />
      </Tooltip>
    </ClickAwayListener>
  )
}
